// store/data/selectors.ts

import { RootState } from '../index';

// ------------------------------------ BASIC SELECTORS ONLY ------------------------------------

// Raw data
export const selectStudyData = (state: RootState) => state.data.studyData;
export const selectCompanyData = (state: RootState) => state.data.companyData;

// Loading states
export const selectStudyDataLoading = (state: RootState) => state.data.isLoadingStudyData;
export const selectCompanyDataLoading = (state: RootState) => state.data.isLoadingCompanyData;

// Error states
export const selectStudyDataError = (state: RootState) => state.data.studyDataError;
export const selectCompanyDataError = (state: RootState) => state.data.companyDataError;

// Counts
export const selectStudyDataCount = (state: RootState) => state.data.studyDataCount;
export const selectCompanyDataCount = (state: RootState) => state.data.companyDataCount;

// Last updated
export const selectLastUpdated = (state: RootState) => state.data.lastUpdated;
